// src/routes.js
import React from 'react';
import { Router, Route } from 'react-router';

import FrontPage from './components/FrontPage/FrontPage';
import UsersPage from './components/UsersPage/UsersPage';
import CategoriesPage from './components/CategoriesPage/CategoriesPage';
import LoginPage from './components/LoginPage';
import NameSearchPage from './components/NameSearchPage';
import IndustriesPage from './components/IndustriesPage/IndustriesPage';
import UnpublishedPage from './components/UnpublishedPage';

import auth from './service/auth';

const Routes = (props) => (
  <Router {...props}>
    <Route path="/" component={FrontPage} onEnter={auth.requireAuth} />
    <Route path="/users" component={UsersPage} onEnter={auth.requireAuth} />
    <Route path="/categories" component={CategoriesPage} onEnter={auth.requireAuth} />
    <Route path="/unpublished" component={UnpublishedPage} onEnter={auth.requireAuth} />
    <Route path="/industries" component={IndustriesPage} onEnter={auth.requireAuth} />
    <Route path="/namesearch" component={NameSearchPage} onEnter={auth.requireAuth} />
    <Route path="/login" component={LoginPage} />
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js